module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/washington-ab9fd9a49a0433afb2c3623780a61cc2.jpg";